import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { VoucherScannerAndTrigger } from "./VoucherScannerAndTrigger.js";
function VoucherScannerAndTriggerContainer(props) {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      modalTitle: getLabel("cart.codeScanner.modalTitle"),
      triggerButtonCaption: getLabel("cart.codeScanner.triggerButtonCaption"),
      loadingText: getLabel("common.loadingText"),
      title: getLabel("cart.codeScanner.title"),
      description: getLabel("cart.codeScanner.description"),
      permissionDeniedErrorTitle: getLabel("cart.codeScanner.permissionDeniedErrorTitle"),
      permissionDeniedErrorDescription: getLabel(
        "cart.codeScanner.permissionDeniedErrorDescription"
      ),
      otherErrorTitle: getLabel("cart.codeScanner.otherErrorTitle"),
      otherErrorDescription: getLabel("cart.codeScanner.otherErrorDescription")
    }),
    [getLabel]
  );
  return /* @__PURE__ */ React.createElement(VoucherScannerAndTrigger, { ...props, labels });
}
export {
  VoucherScannerAndTriggerContainer
};
//# sourceMappingURL=VoucherScannerAndTriggerContainer.js.map
